import { render, staticRenderFns } from "./CustomerBuildingPricer.vue?vue&type=template&id=227e1c9a&scoped=true&"
import script from "./CustomerBuildingPricer.vue?vue&type=script&lang=js&"
export * from "./CustomerBuildingPricer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBuildingPricer.vue?vue&type=style&index=0&id=227e1c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e1c9a",
  null
  
)

export default component.exports